export const debounce = (func, ms) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, ms);
  };
};

export function areEqualValues(first, second) {
  if (typeof second === 'object' && second !== null) {
    return first === second;
  }
  return String(first) === String(second);
}

export function createChainedFunction() {
  // eslint-disable-next-line prefer-rest-params
  const args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }
  return function chainedFunction() {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < args.length; i++) {
      // eslint-disable-next-line prefer-rest-params
      if (args[i] && args[i].apply) {
        // eslint-disable-next-line prefer-rest-params
        args[i].apply(this, arguments);
      }
    }
  };
}

export function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn?.(event);
      return event?.defaultPrevented;
    });
  };
}
